const KEY = 'askjyotish.last_login'

export interface LastLogin {
  display_name: string
  email: string
  provider: 'google' | 'apple'
}

export function saveLastLogin(info: LastLogin) {
  try {
    localStorage.setItem(KEY, JSON.stringify(info))
  } catch {
    // ignore
  }
}

export function getLastLogin(): LastLogin | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as LastLogin
    if (!parsed.provider || !parsed.email) return null
    return parsed
  } catch {
    return null
  }
}

export function clearLastLogin() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}
